import React from 'react';

// Nexus Core Design System (DESIGN.md §5.2) - Surface Card
export default function Card({
  children,
  title,
  headerActions,
  padding = 'p-6',
  className = '',
  ...props
}) {
  return (
    <div
      className={`bg-surface-container-lowest rounded-xl border border-border-light shadow-sm ${padding} ${className}`}
      {...props}
    >
      {(title || headerActions) && (
        <div className="flex items-center justify-between mb-4">
          {title && (
            <h3 className="text-lg font-semibold text-text-primary">{title}</h3>
          )}
          {headerActions && (
            <div className="flex items-center gap-2">{headerActions}</div>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
